import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-scroll';

import FrameList from '../../item/FrameList';
import Frame from '../../Frame/Frame';
import ImageList from '../../image/ImageList';
import ContactInfo from '../ContactInfo/ContactInfo';
import MessageReducer from '../../../modules/reducers/MessageReducer';
import Loading from '../../../components/common/organism/Loading';
import { updateConversionRequest } from './OrderDetailApi';
import { STATUS_MESSAGE } from '../../../lib/Error';
import { Text } from '../../../components/common/atom/Text';
import OrderDetailShortForm from './OrderDetailShortForm';
import { HorizonGreyLine } from '../../../components/common/atom/HorizonGreyLine';
import { Flex } from '../../../components/common/atom/Layout';
import { Button } from '../../../components/common/atom/Button';
import { ArrowToggleChildren } from '../../../components/common/organism/Toggle';
import {
  BabyfaceFirstInfo,
  BabyfaceSecondInfo,
  MessageToBaby,
} from '../Item/OrderInfoInput';
import { AnchorToKakaoCs } from '../../../components/common/atom/Anchor';

const ConversionUpdateStatusSet = [
  'READY',
  'PENDING_DEPOSIT',
  'PAID',
  'READY_FOR_WORK',
  'INSPECTING',
];

// const UpdateStatusSet = ConversionUpdateStatusSet.concat('REVIEW');

const PaymentMethodSet = [
  ['VIRTUAL_ACCOUNT', '가상계좌'],
  ['CREDIT_CARD', '신용카드'],
  ['KAKAO_PAY', '카카오페이'],
  ['VOUCHER', '상품권'],
  ['NONE', '운영자'],
];

const OrderDetailView = ({ data }) => {
  const order = { ...data };

  const [changeStatus, setChangeStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [updateLock, setUpdateLock] = useState(true);
  const [conversionUpdateLock, setConversionUpdateLock] = useState(true);
  const [photoFrame, setPhotoFrame] = useState(false);
  const [selectedFrame, setSelectedFrame] = useState(null);
  const [hospitalName, setHospitalName] = useState('');
  const [babyGender, setBabyGender] = useState('');
  const [itemId, setItemId] = useState(null);
  const [note, setNote] = useState('');
  const [
    messageObject,
    setMessageObject,
    onChangeMessageObject,
  ] = MessageReducer({
    message: '',
    messageValid: true,
  });
  const { message, messageValid } = messageObject;
  const ULTRASOUND = 'ULTRASOUND';

  const setInitialState = () => {
    setMessageObject({
      message: order.items[0].additionalInfo.message,
    });
    setItemId(order.items[0].id);
    setSelectedFrame(order.items[0].additionalInfo.imageFrameAlias);
    setBabyGender(order.items[0].additionalInfo.babyGender);
    setNote(order.items[0].additionalInfo.note);
    setPhotoFrame(order.items[0].additionalInfo.photoFrame);
    setHospitalName(order.items[0].additionalInfo.hospitalName);
  };
  // 화면 채우기
  useEffect(() => {
    setInitialState();
    // if (UpdateStatusSet.indexOf(order.items[0].status) > -1) {
    //   setUpdateLock(false);
    // }
    if (ConversionUpdateStatusSet.indexOf(order.items[0].status) > -1) {
      setConversionUpdateLock(false);
    }
  }, [data]);

  const onClickUpdateConversionRequest = useCallback(() => {
    if (!messageValid) {
      alert(STATUS_MESSAGE.order.validate.messageToBaby);
      return;
    }
    if (!selectedFrame) {
      alert('프레임을 선택해주세요');
      return;
    }
    setLoading(true);
    updateConversionRequest({
      itemId,
      imageFrameAlias: selectedFrame,
      babyGender,
      message,
      photoFrame,
      note,
      hospitalName,
    }).then((response) => {
      setBabyGender(response.additionalInfo.babyGender);
      setHospitalName(response.additionalInfo.hospitalName);
      setSelectedFrame(response.additionalInfo.imageFrameAlias);
      setMessageObject({ message: response.additionalInfo.message });
      setPhotoFrame(response.additionalInfo.photoFrame);
      setLoading(false);
      setNote(response.additionalInfo.note);
    });
    setChangeStatus(false);
  }, [itemId, selectedFrame, babyGender, message, photoFrame, note]);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <OrderDetailViewTemplate data={order}>
          {order.contactInfo !== null && (
            <ContactInfo contactInfo={order.contactInfo} orderId={order.id} shipmentRequired={order.shipmentRequired} />
          )}
          <HorizonGreyLine id="orderInfo" />
          <ArrowToggleChildren title="신청서 정보">
            <BabyfaceFirstInfo
              title="1. 초음파 사진"
              babyGender={babyGender}
              disabled={!changeStatus || conversionUpdateLock}
              onChangeBabyGender={(e) => setBabyGender(e.target.value)}
              onChangeHospitalName={(e) => setHospitalName(e.target.value)}
              hospitalName={hospitalName}
              note={note}
              onChangeNote={(e) => setNote(e.target.value)}
            >
              {itemId !== null && (
                <ImageList
                  itemId={itemId}
                  imageType={ULTRASOUND}
                  updateAvailable={changeStatus && !conversionUpdateLock}
                  multipleOption={false}
                  limitedNum={1}
                />
              )}
            </BabyfaceFirstInfo>
            <BabyfaceSecondInfo title="2. 프레임">
              <>
                <Text
                  color="orangePink"
                  size={12}
                  style={{ marginBottom: changeStatus ? '0.625rem' : 0 }}
                >
                  * 결과사진이 아닌 선택하신 프레임의 예시 사진입니다.
                </Text>
                {changeStatus && (
                  <FrameList
                    selectedFrame={selectedFrame}
                    inspectingLock={conversionUpdateLock}
                    onSelectFrame={({ selectedFrame }) => {
                      setSelectedFrame(selectedFrame);
                    }}
                  />
                )}
                {selectedFrame && <Frame alias={selectedFrame} />}
              </>
              <MessageToBaby
                message={message}
                disabled={!(changeStatus && !conversionUpdateLock)}
                onChangeMessage={(e) =>
                  onChangeMessageObject({ message: e.target.value })
                }
                onClickAddHeart={(e) =>
                  onChangeMessageObject({
                    message: message.concat(
                      e.target.innerText === 'favorite_border' ? '♡' : '♥',
                    ),
                  })
                }
              />
            </BabyfaceSecondInfo>

            {order.items[0].status !== 'SHIPPING_COMPLETED' &&
            order.items[0].status !== 'REFUNDED' &&
            changeStatus ? (
              <EditButton
                onChangeStatus={() => {
                  setInitialState();
                  setChangeStatus(false);
                }}
                onSubmit={onClickUpdateConversionRequest}
              />
            ) : (
              <Flex column padding="0 0 1.25rem" width="100%">
                {conversionUpdateLock ? (
                  <Text
                    size={12}
                    color="orangePink"
                    style={{ marginBottom: '0.625rem' }}
                  >
                    * 작업단계에서는 수정할 수 없습니다.
                    <br />
                    <AnchorToKakaoCs>
                      <b style={{ textDecoration: 'underline' }}>
                        카카오 플러스 친구 [베이비페이스 고객센터]
                      </b>
                    </AnchorToKakaoCs>
                    에 문의 해주세요.
                  </Text>
                ) : (
                  <Link
                    to="orderInfo"
                    spy={true}
                    smooth={true}
                    duration={500}
                    style={{
                      width: '50%',
                    }}
                  >
                    <Button
                      onClick={() => setChangeStatus(!conversionUpdateLock)}
                      color="orangePink"
                    >
                      <Text size="14">수정하기</Text>
                    </Button>
                  </Link>
                )}
              </Flex>
            )}
          </ArrowToggleChildren>
        </OrderDetailViewTemplate>
      )}
      <HorizonGreyLine />
    </>
  );
};

export default React.memo(OrderDetailView);

export const OrderDetailViewTemplate = ({ children, data }) => {
  const {
    defaultPrice,
    finalShippingFee,
    finalPrice,
    paymentMethod,
    vbankName,
    vbankNum,
    vbankDeadline,
    paymentCompleteTime,
  } = data;

  const PaymentInfoList = [
    ['상품 금액', `${defaultPrice.toLocaleString()}원`],
    ['배송비', `${finalShippingFee.toLocaleString()}원`],
    [
      '할인/쿠폰 금액',
      `-${(defaultPrice - (finalPrice - finalShippingFee)).toLocaleString()}원`,
    ],
    ['최종 결제 금액', `${finalPrice.toLocaleString()}원`],
    [
      '결제수단',
      PaymentMethodSet.filter(
        (PaymentMethod) => PaymentMethod[0] === paymentMethod,
      )[0][1],
    ],
    ['입금은행', vbankName],
    ['가상계좌', vbankNum],
    // ['입금금액', order.finalPrice + '원'],
    ['입금기한', vbankDeadline],
    paymentMethod === 'VIRTUAL_ACCOUNT' && [
      '입금확인 날짜',
      paymentCompleteTime,
    ],
  ];
  return (
    <>
      <Flex column alignItems="stretch" padding="0 0 1.875rem">
        <Flex justifyContent="flex-start">
          <Text size="14" weight="medium">
            주문상품
          </Text>
          <Text size={12} color="orangePink" style={{ marginLeft: '0.313rem' }}>
            총 1건
          </Text>
        </Flex>
        <OrderDetailShortForm order={data} />
      </Flex>
      <HorizonGreyLine />
      <OrderDetailLayout title="결제정보" infoList={PaymentInfoList} />
      <HorizonGreyLine />
      {children}
    </>
  );
};

export const OrderDetailLayout = ({ title, infoList }) => (
  <OrderDetailLayoutWithChildren title={title}>
    {infoList.map(
      (info, index) =>
        info[1] && (
          <Flex key={index} justifyContent="flex-start">
            <Text size={12} lineHeight={2} style={{ flex: 1 }}>
              {info[0]}
            </Text>
            <Text size={12} lineHeight={2} style={{ flex: 2 }}>
              {info[1]}
            </Text>
          </Flex>
        ),
    )}
  </OrderDetailLayoutWithChildren>
);

export const OrderDetailLayoutWithChildren = ({ title, children }) => (
  <Flex column alignItems="strecth" padding="1.25rem 0">
    <Text size="14" weight="medium" style={{ marginBottom: '1.25rem' }}>
      {title}
    </Text>
    {children}
  </Flex>
);

export const EditButton = ({ onChangeStatus, onSubmit, isEditLoading }) => (
  <Flex width="100%" padding="0 0 1.25rem">
    <Button
      color="brownGrey"
      onClick={onChangeStatus}
      style={{ height: '2.5rem' }}
    >
      <Text size="14">수정취소</Text>
    </Button>
    <Button
      onClick={onSubmit}
      style={{ marginLeft: '3.75rem', height: '2.5rem' }}
      isLoading={isEditLoading}
    >
      <Text size="14">수정완료</Text>
    </Button>
  </Flex>
);
